import { Divider, Typography } from "@mui/material"
import RandomQueueAdder from "./RandomQueueAdder"
import RandomQueueItem from "./RandomQueueItem"
import ExpandingArrow from "../common/buttons/ExpandingArrow"
import { useEffect, useState } from "react"
import CollapsibleContainer from "../common/containers/CollapsibleContainer"
import { useSelector } from "react-redux"
import { isEditingQueue } from "../../reducers/randomMode"

const PreviousAlbumsDisplayer = ({previousAlbums, canAdd}) => {
    const [expanded, setExpanded] = useState(false);
    const editingMode = useSelector(isEditingQueue);

    useEffect(() => {
        if(!previousAlbums || previousAlbums.length === 0)
        {
            setExpanded(false);
        }
    }, [previousAlbums, setExpanded]);

    const PreviousAlbumDisplayer = (album, index) => {
        return (
            <div key={index} className="d-flex flex-column jc-center ai-center gap-0_5 full-width">
                <RandomQueueAdder 
                    queueIndex={index} 
                    visible={canAdd && editingMode} 
                />
                <RandomQueueItem
                    album={album}
                    queueIndex={index}
                    canDeleteAlbum={true}
                />
            </div>
        )
    }

    return (
        <>
        {
            <div className="d-flex flex-column jc-center ai-center full-width">
                <div className="full-width">
                    <div className="full-width d-flex flex-row jc-space-between ai-center">
                        <Typography variant="subtitle1">Previous albums</Typography>
                        <ExpandingArrow 
                            size="small" 
                            expanded={expanded} setExpanded={setExpanded}
                            disabled={!previousAlbums || previousAlbums.length === 0} />
                    </div>
                    <Divider />
                </div>
                <div className={`d-flex flex-column jc-center ai-center full-width`}>
                    <div className="full-width previous-albums-collapsible">
                        <CollapsibleContainer expanded={expanded}>
                            <div className="d-flex flex-column jc-center ai-center gap-0_5 full-width pt-1 pb-0_5">
                                {
                                    previousAlbums.map(PreviousAlbumDisplayer)
                                }
                            </div>
                        </CollapsibleContainer>
                    </div>
                    <RandomQueueAdder queueIndex={previousAlbums.length} visible={canAdd && editingMode} onAdd={() => setExpanded(true)} />
                </div>
            </div>
        }
        </>
    )
}

export default PreviousAlbumsDisplayer;